import { useLocation } from 'react-router-dom';

export const useIsEmbed = (): boolean => {
  const { pathname } = useLocation();
  return pathname.includes('/embed/');
};

